import React from 'react';
//import { Link } from 'react-router-dom';
import { Level, Title } from 'rbx';
import styled from 'styled-components';
import { SubHeading } from '../../../components/elements';

const Wrapper = styled.div`
  padding: 1rem;
  .level:not(:last-child) {
    margin-bottom: 0;
  }
`;

const Header = ({ heading, handleSubmit, loading, next, prev }) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Title size={2}>{heading}</Title>
      </Level.Item>
      <Level.Item align="right">
      <Level.Item>
          <button onClick={prev} className="button is-light">
            <span>Cancel</span>
          </button>
        </Level.Item>
        <Level.Item>
          <button onClick={prev} className="button is-primary">
            <span>Prev Tab</span>
          </button>
        </Level.Item>

        <Level.Item>
          <button className="button is-primary">
            <span>Submit</span>
          </button>
        </Level.Item>

        <Level.Item>
          <button onClick={next} className="button is-primary">
            <span>Next Tab</span>
          </button>
        </Level.Item>
      </Level.Item>
    </Level>
    <Level>
      <Level.Item align="left">
        <SubHeading>
          <Title size={2}>Spicy Dragon</Title>
        </SubHeading>
        <SubHeading className="is-size-2">
          | St Kilda, 3182|Australia
        </SubHeading>
      </Level.Item>
    </Level>
  </Wrapper>
);

export default Header;
